/** Post-purchase collapsible description chevrons (Shopify surface). */
export const DESCRIPTION_CHEVRON_SIZE = 10;
export const DESCRIPTION_CHEVRON_FILL = "#737373";

export const DESCRIPTION_CHEVRON_DOWN_PATH =
  "M9 2.14282L10 3.14282L6 7.14282L5 8.14282L4 7.14282L0 3.14282L1 2.14282L5 6.14282";

export const DESCRIPTION_CHEVRON_UP_PATH =
  "M1 7.42847L0 6.42847L5 1.42847L10 6.42847L9 7.42847L5 3.42847L1 7.42847Z";

export const DESCRIPTION_CHEVRON_DOWN_SVG = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="${DESCRIPTION_CHEVRON_DOWN_PATH}" fill="${DESCRIPTION_CHEVRON_FILL}"></path></svg>`;

export const DESCRIPTION_CHEVRON_UP_SVG = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="${DESCRIPTION_CHEVRON_UP_PATH}" fill="${DESCRIPTION_CHEVRON_FILL}"></path></svg>`;

export function getDescriptionChevronDataUri(expanded = false) {
  const svg = expanded ? DESCRIPTION_CHEVRON_UP_SVG : DESCRIPTION_CHEVRON_DOWN_SVG;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
}
